import {toggle} from 'opticks'

import {GuestReviewLayout} from './constants'

export enum GuestReviewLayoutConfig {
  ReviewsRating = 'reviewsRating',
  ReviewsCarousel = 'reviewsCarousel',
  ReviewsSummary = 'reviewsSummary',
  ReviewComments = 'reviewComments'
}

const layoutConfigDefault = toggle(
  '9633c72c-guest-reviews-sort-filter',
  [
    GuestReviewLayoutConfig.ReviewsRating,
    GuestReviewLayoutConfig.ReviewsCarousel,
    GuestReviewLayoutConfig.ReviewsSummary
  ],
  [
    GuestReviewLayoutConfig.ReviewsRating,
    GuestReviewLayoutConfig.ReviewsSummary,
    GuestReviewLayoutConfig.ReviewsCarousel
  ]
)
const layoutConfigFull = [
  GuestReviewLayoutConfig.ReviewsRating,
  GuestReviewLayoutConfig.ReviewsSummary,
  GuestReviewLayoutConfig.ReviewComments
]

export const layoutConfigMapping = {
  [GuestReviewLayout.DEFAULT]: layoutConfigDefault,
  [GuestReviewLayout.FULL]: layoutConfigFull
}
